// 🛠️ Hook: useValidateRiskAssessment.js
import { createValidator } from "../../utils/validation";
import { riskAssesmentcontinuedInfoSchema } from "../validationRules/riskAssesmentContinuedInfoForm";
export const useValidateRiskAssessmentContinued = () => {
    const validateRiskAssesmemntContinued = (formData, showSections = []) => {
        const sectionFieldMap = {
            pepOwner: ["UKpep", "PepJurisdiction", "PepType", "PepDescription"],
            sanctionedPerson: [
              "Aliases",
              "SanctionedYear",
              "sanctionReason",
              "UKsanctioned",
              "mitigatingFactors",
             
              "FactorDetails"
            ],
            sectorFromDropdown: [ "knownCovenant","operatingYear"],
            pepEvasive: ["unwillingInformation", "DelayReason", "RequestMissingInfo"],
            transactionCompletedWithUndueSpeed: ["timeframe", "urgencyReason", "urgencyEvent"],
            adverseInformation: [
              "adverseInformation",
              "coverageSource",
             "coverageDetail",
              "adversePublicity",
              "findingsInvestigation"
            ],
            criminalProceedings: [
              "offenseNature",
              "OffenceReason",
              "whiteCollarOffence",
              "proceedingsVoluntarily",
              "reputationalConcerns"
            ],
            taxInvasionIndication: ["subjectAllegations", "AllegationsDetails"]
          };
  
      let customValidator = {};
  
      showSections.forEach((section) => {
        const fields = sectionFieldMap[section];
        if (fields) {
          fields.forEach((field) => {
            // ✅ Skip PepType if UKpep is not "Yes"
            if (section === "pepOwner") {
              if (field === "PepType" && formData.UKpep !== "Yes") return;
              if (field === "PepJurisdiction" && formData.UKpep === "Yes") return;
              if (field === "PepDescription" && formData.PepType !== "Other") return;
            }

            if (section === "sanctionedPerson") {
              if (field === "FactorDetails" && formData.mitigatingFactors !== "Yes") return;
             
            }

            if (section === "adverseInformation" && field === "coverageDetail") {
              if (formData.coverageSource !== "Other") return;
            }
            
  
            if (riskAssesmentcontinuedInfoSchema[field]) {
              customValidator[field] = riskAssesmentcontinuedInfoSchema[field];
            }
          });
        }
      });
  
      const validator = createValidator(customValidator);
      return validator(formData);
    };
  
    return { validateRiskAssesmemntContinued };
  };
  